import React from "react";

const OrganDonor = ({ data }) => (
  <div>
    <h4>Organ Donor</h4>
    <div>{data[0].valueBoolean ? "Yes" : "No"}</div>
  </div>
);

export default OrganDonor;
